// This user pool data is set within AWS and decides what pool (like database)
// have access to the app. As well as where they are saved.
export const USER_POOL_DATA = {
    UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    ClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID
};
